export default __webpack_public_path__ + "915e82bedd4fb8e15f89078b3d0f20fa.png";